<template>
    <div>
        <el-form-item label="Zaznaczanie wielu"
                      :error="errors['multiple']">
            <el-switch v-model="form['multiple']"/>
        </el-form-item>
        <el-form-item label="Opcje do wyboru"
                      required>
            <el-collapse class="formset__list">
                <div v-for="choice, index in form.choices">
                    <div class="formset__header">
                        <span>
                             <el-form-item label=""
                                           :error="errors.choices && errors.choices[index][addLanguageSuffix('label')]"
                                           required>
                            <el-input placeholder="Nazwa opcji"
                                      @input="$forceUpdate()"
                                      v-model="choice[addLanguageSuffix('label')]"/>
                             </el-form-item>
                        </span>
                        <div class="formset__header__buttons">
                            <el-button @click.stop="removeChoice(choice)"
                                       type="danger"
                                       size="small"
                                       title="Usuń element">
                                <i class="fa fa-remove"></i>
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-collapse>
            <el-button class="fluid"
                       type="primary"
                       @click="addChoice">
                Dodaj opcję
            </el-button>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors'],
        methods: {
            addChoice () {
                if (this.form.choices === undefined) this.form.choices = []
                this.form.choices.push({})
                this.$forceUpdate()
            },
            removeChoice (choice) {
                this.removeItemFromFormset(this.form.choices, choice)
                this.$forceUpdate()
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// ChoiceField.vue?cc28a11c